import { validateForm } from '../utils';
import useUser from '../../../user';
import { getFormValues, getStepFieldValue } from '../utils';
import { useSelector } from 'react-redux';

const useLogin = () => {
  const { login } = useUser();
  const { dataLinks } = useSelector(state => state.DataLinks);

  const loginUser = async ({
    step,
    history,
    documents,
    selections,
    local,
    params,
    data
  }) => {
    let payload = {};
    if (step.formId) {
      if (!validateForm({ formId: step.formId })) {
        return { error: 'invalid form values' };
      }

      payload = getFormValues({ formId: step.formId, returnObject: true });
    }

    step.fields
      ?.filter(f => f.value.toString().indexOf('{data.') === -1)
      .forEach(stepField => {
        const fieldValue = getStepFieldValue({
          stepField,
          underlyingField: {
            type: stepField.fieldType
          },
          selections,
          history,
          documents,
          local,
          dataLinks,
          data,
          params
        });

        // make sure text fields are no co-erced to numbers if the contain number strings
        if (stepField?.type === 'string' && fieldValue?.toString) {
          payload[stepField.name] = fieldValue.toString();
        } else {
          payload[stepField.name] = fieldValue;
        }
      });

    return await login(payload.email, payload.password);
  };

  return {
    loginUser
  };
};

export default useLogin;
